import { StyleSheet } from 'react-native';

import { initialWindowMetrics } from 'react-native-safe-area-context';

import { COLOR } from 'utils/colors';
import { isAndroid15 } from 'utils/responsiveness';

const styles = StyleSheet.create({
    safeAreaView: {
        flex: 1,
        backgroundColor: COLOR.background,
        paddingTop: isAndroid15 ? initialWindowMetrics?.insets.top : 0,
    },
});

export default styles;
